import React from 'react';
import { DialogContent, DialogOptions } from './styled';
import { Button } from 'react-materialize';

export function ModalConfirm({ handleConfirm, handleCancel }) {
  return (
    <DialogOptions>
      <DialogContent
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <h2>Ao sair dessa página você perderá os dados atuais</h2>

        <span style={{ fontWeight: '500', fontSize: '1.2rem' }}>Deseja continuar?</span>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', width: '100%' }}>
          <Button style={{ width: "100%" }} onClick={handleConfirm} className="waves-effect waves-light saib-button is-primary">
            Confirmar
          </Button>
          <Button style={{ width: "100%" }} onClick={handleCancel} className="waves-effect waves-light saib-button is-secondary">
            Cancelar
          </Button>
        </div>
      </DialogContent>
    </DialogOptions>
  );
}
